import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root'
})
export class MapsService extends BaseService {
  constructor(private http: HttpClient) { super(); }

  getField(id: number): Observable<any> {
    return this.http.get(`${this.getUrl('Fields')}/${id}`);
  }

  getAreas(): Observable<any> {
    return this.http.get(`${this.getUrl('Areas/Polygons')}`);
  }

  getFields(): Observable<any> {
    return this.http.get(`${this.getUrl('Fields/Polygons')}`);
  }
}
